/**
 * KANBAN SLICE — stato delle bacheche core.
 */

import { createSlice } from '@reduxjs/toolkit';
import { addCrudCases } from '../../store/addCrudCases';
import { kanbanThunks } from './kanbanThunks';
import type { KanbanSliceState } from './kanbanTypes';

const initialState: KanbanSliceState = {
  items: [],
  byId: {},
  currentItem: null,
  status: 'idle',
  error: null,
  totalCount: 0,
};

export const kanbanSlice = createSlice({
  name: 'kanbans',
  initialState,
  reducers: {
    clearCurrentKanban(state) {
      state.currentItem = null;
    },
  },
  extraReducers: (builder) => {
    addCrudCases(builder, kanbanThunks, (k) => k.kanbanId);
  },
});

export const { clearCurrentKanban } = kanbanSlice.actions;
export const kanbanReducer = kanbanSlice.reducer;
